import React, { FC, forwardRef } from 'react';
import { Search as SearchIcon } from '@wix/wix-ui-icons-common';
import { Search as HarmonySearchIcon } from '@wix/wix-ui-icons-common/odeditor';
import { useIsStudio2Ui } from '../../hooks/useIsStudio2Ui';
import { useTranslation } from '@wix/wix-i18n-config';

import {
  SearchSuggestions,
  Suggestion,
} from '../SearchSuggestions/SearchSuggestions';

import s from './Search.scss';
import cs from 'classnames';
import { isCategorySlug } from '../../config';

interface SearchProps {
  withSuggestions?: boolean;
  className?: string;
  value?: string;
  onChange?: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  autoFocus?: boolean;
  onCloseClick?: () => void;
  onKeyUp?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onSuggestionClick?: (value: Suggestion) => void;
}

export const Search = forwardRef<HTMLInputElement, SearchProps>(
  (
    {
      withSuggestions,
      className,
      onChange,
      value,
      autoFocus,
      onBlur,
      onFocus,
      onCloseClick,
      onKeyUp,
      onSuggestionClick,
    },
    inputRef,
  ) => {
    const { t } = useTranslation();
    const isStudio2Ui = useIsStudio2Ui();

    return (
      <div className={s.container}>
        <div className={cs(s.inputContainer, className)}>
          <div className={s.searchIcon}>
            {isStudio2Ui ? (
              <HarmonySearchIcon className={s.searchIcon} />
            ) : (
              <SearchIcon className={s.searchIcon} />
            )}
          </div>
          <input
            value={value}
            ref={inputRef}
            onChange={(e) => onChange?.(e.target.value)}
            className={s.input}
            onKeyUp={onKeyUp}
            autoFocus={autoFocus}
            onFocus={onFocus}
            onBlur={onBlur}
            placeholder={t('app.main.header.input.placeholder')}
          />
          {value && (
            <div onClick={onCloseClick} className={s.clearButton}>
              <div className={s.crossIcon} />
            </div>
          )}
        </div>
        {withSuggestions && (
          <SearchSuggestions onSuggestionClick={onSuggestionClick} />
        )}
      </div>
    );
  },
);
